import React, { useState, useEffect } from "react";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import "animate.css/animate.css";
import './styles/TagDropdown.css';

const TagDropdown = (props) => {
  const [value, setValue] = useState(null);
  const tipText =  props.prompt?props.prompt:'';
  const validationCase = props.validationCase || 'none';
  const isTagChecked = props.isTagChecked || false;
  const isAlwaysOn = props.isAlwaysOn || false;

  useEffect(() => {
    setValue(props.choices.find(obj => (obj.value ?? obj.label) === props.value) || null);
  },[props.choices,props.value]);

  const isEmpty = !value;
  const error =
    (validationCase === 'case_4' && props.required && isAlwaysOn && isEmpty) ||
    (validationCase === 'case_2' && props.required && isTagChecked && isEmpty);
  const helperText = error
    ? (validationCase === 'case_4' ? 'This field is required' : 'This field is required if active')
    : '';

  const handleChange = (event, newValue) => {
    props.onChange({
      name: props.param,
      value: newValue.value ?? newValue.label,
    });
    setValue(newValue);
  };

  return (
    <Grid container className="tag-dropdown-container">
      <Grid item xs={12} sm={12}>
        <Tooltip title={tipText} placement="top" arrow>
          <Autocomplete
            value={value}
            onChange={handleChange}
            options={props.choices}
            isOptionEqualToValue={(option, val) => (option.value ?? option.label) === (val?.value ?? val?.label)}
            className="tag-dropdown-autocomplete"
            size="small"
            disableClearable
            renderInput={(params) => (
              <TextField
                {...params}
                label={props.label}
                error={error}
                helperText={helperText}
              />
            )}
          />
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default TagDropdown;
